// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-icons {
  /*overflow: hidden;*/
  max-height: 215px;
  height: 100%;
}
.admin-icons .rec.rec-carousel-wrapper .rec-pagination {
  margin-top: 15px;
}
.admin-icons .rec.rec-carousel-wrapper .rec-pagination .rec-dot {
  background: #caa36c;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  box-shadow: none;
  font-size: inherit;
  padding: 0;
  opacity: 0.3;
}
.admin-icons .rec.rec-carousel-wrapper .rec-pagination .rec-dot.rec-dot_active {
  opacity: 1;
}
.admin-icons ul.page {
  width: 100%;
}
.admin-icons li {
  width: 25%;
  float: left;
  transition: 1s;
  max-height: 80px;
  /*height: 21vw;*/
}
.admin-icons li a {
  background-color: #f5f5f5;
  border-radius: 10px;
  position: relative;
  display: block;
  margin: 5px;
  transition: background-color 0.5s;
}
.admin-icons li a.selected {
  background-color: #caa36c;
}
.admin-icons li a:before {
  content: "";
  display: block;
  padding-bottom: 100%;
}
.admin-icons li a .icon-button {
  transform: translate(-50%, -50%);
  position: absolute;
  text-align: center;
  width: 100%;
  left: 50%;
  top: 50%;
}
.admin-icons li a .icon-button .icon {
  display: inline;
  max-height: 53px;
  max-width: 53px;
  filter: invert(1);
}
.admin-icons li a .icon-button span {
  font: 1.2em/1 "vigaregular";
  margin-top: 16px;
  display: block;
  color: #fff;
}
.admin-icons li a .icon-button.selected .icon {
  filter: invert(0);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/partials/Icons.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,iBAAA;EACA,YAAA;AACF;AAGI;EACE,gBAAA;AADN;AAEM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAAR;AACQ;EACE,UAAA;AACV;AAOE;EACE,WAAA;AALJ;AAQE;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AANJ;AAQI;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iCAAA;AANN;AAQM;EACE,yBAAA;AANR;AASM;EACE,WAAA;EACA,cAAA;EACA,oBAAA;AAPR;AAUM;EACE,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;AARR;AAUQ;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AARV;AAWQ;EACE,2BAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AATV;AAaU;EACE,iBAAA;AAXZ","sourcesContent":[".admin-icons {\n  /*overflow: hidden;*/\n  max-height: 215px;\n  height: 100%;\n\n .rec.rec-carousel-wrapper {\n\n    .rec-pagination{\n      margin-top: 15px;\n      .rec-dot{\n        background: #caa36c;\n        border-radius: 50%;\n        width: 10px;\n        height: 10px;\n        box-shadow: none;\n        font-size: inherit;\n        padding: 0;\n        opacity: 0.3;\n        &.rec-dot_active{\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n\n\n  ul.page{\n    width: 100%;\n  }\n\n  li {\n    width: calc(100% / 4);\n    float: left;\n    transition: 1s;\n    max-height: 80px;\n    /*height: 21vw;*/\n\n    a {\n      background-color: #f5f5f5;\n      border-radius: 10px;\n      position: relative;\n      display: block;\n      margin: 5px;\n      transition: background-color 0.5s;\n\n      &.selected {\n        background-color: #caa36c;\n      }\n\n      &:before {\n        content: \"\"; \n        display: block;\n        padding-bottom: 100%;\n      }\n\n      .icon-button {\n        transform: translate(-50%, -50%);\n        position: absolute;\n        text-align: center;\n        width: 100%;\n        left: 50%;\n        top: 50%;\n\n        .icon {\n          display: inline;\n          max-height: 53px;\n          max-width: 53px;\n          filter: invert(1);\n        }\n\n        span {\n          font: 1.2em/1 \"vigaregular\";\n          margin-top: 16px;\n          display: block;\n          color: #fff;\n        }\n\n        &.selected {\n          .icon {\n            filter: invert(0);\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
